import { useTranslation } from "react-i18next";

export default function FooterSection() {
  const { t } = useTranslation();
  const services = t("footer.services.items", { returnObjects: true });
  const locations = t("footer.locations.items", { returnObjects: true });

  return (
    <footer id="contact" className="bg-[#111111] px-5 pb-10 pt-16 text-white sm:px-10 sm:pt-20 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-10 border-b border-white/15 py-12 lg:grid-cols-[1.15fr_0.85fr] lg:items-end">
          <div>
            <p className="text-xs font-semibold uppercase text-[#B08D57]">{t("footer.cta_label")}</p>
            <h2 className="mt-6 max-w-4xl text-4xl font-semibold leading-none sm:text-5xl lg:text-6xl">{t("footer.cta_title")}</h2>
          </div>
          <div className="lg:text-right">
            <p className="text-lg leading-8 text-white/90">{t("footer.cta_body")}</p>
            <a
              className="mt-8 inline-flex min-h-14 max-w-full items-center break-all border border-[#B08D57] bg-[#B08D57] px-5 py-4 text-sm font-semibold uppercase text-[#111111] transition duration-200 hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#B08D57] sm:break-normal sm:px-7"
              href="mailto:info@sodevaconsulting.com"
            >
              info@sodevaconsulting.com
            </a>
          </div>
        </div>

        <div className="grid gap-12 py-14 lg:grid-cols-[1.1fr_2fr]">
          <div>
            <img src="/logo.png" alt="Logo" className="h-16 sm:h-20 sm:-ml-4" />
            <p className="mt-5 max-w-sm text-base leading-7 text-white/60">{t("footer.statement")}</p>
          </div>

          <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
            <div>
              <h2 className="text-sm font-semibold text-[#B08D57]">{t("footer.services.title")}</h2>
              <ul className="mt-5 space-y-3 text-sm text-white/70">
                {services.map((service) => (
                  <li key={service}>{service}</li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="text-sm font-semibold text-[#B08D57]">{t("footer.office.title")}</h2>
              <address className="mt-5 not-italic text-sm leading-7 text-white/70">
                <a
                  className="underline decoration-white/30 underline-offset-4 transition duration-200 hover:text-[#B08D57] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#B08D57]"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.google.com/maps/place/Zemstbaan+24,+2800+Mechelen"
                >
                  {t("footer.office.address")}
                </a>
              </address>
            </div>

            <div>
              <h2 className="text-sm font-semibold text-[#B08D57]">{t("footer.locations.title")}</h2>
              <ul className="mt-5 space-y-3 text-sm text-white/70">
                {locations.map((location) => (
                  <li key={location}>{location}</li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="text-sm font-semibold text-[#B08D57]">{t("footer.contact.title")}</h2>
              <div className="mt-5 space-y-3 text-sm text-white/70">
                <p>
                  <a className="transition duration-200 hover:text-[#B08D57]" href="tel:+3215421655">
                    +32(0)15/42 16 55
                  </a>
                </p>
                <p>
                  <a className="transition duration-200 hover:text-[#B08D57]" target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/sodeva-consulting-&-development">
                    LinkedIn
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 border-t border-white/15 pt-6 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>{t("footer.copyright")}</p>
          <a className="w-fit transition duration-200 hover:text-[#B08D57]" href="#top">
            {t("footer.back_to_top")}
          </a>
        </div>
      </div>
    </footer>
  );
}
